import { examinationSchema } from 'apis'
import { SelectEntityItem } from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import { notEmpty } from 'views/Shared'

const ExaminationEntity = ({ item, children, defaultItem }) => (
  <SelectEntityItem
    item={item}
    defaultItem={defaultItem}
    schema={examinationSchema}>
    {(data) => children(data)}
  </SelectEntityItem>
)

export const ExaminationEntities = ({ items, children, defaultItem }) => (
  <SelectEntityItem
    item={items}
    defaultItem={defaultItem}
    schema={[examinationSchema]}>
    {(data = []) => children(_.filter(data, notEmpty))}
  </SelectEntityItem>
)

export default ExaminationEntity
